<template>
  <div class="search-by-search">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-icon :size="32" class="is-loading">
        <Loading />
      </el-icon>
    </div>

    <!-- 搜索结果列表 -->
    <template v-else>
      <el-table :data="displayData" style="width: 100%" class="result-table">
        <el-table-column prop="id" label="编号" width="120">
          <template #default="{ row }">
            <span class="item-name">{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="名称" min-width="200">
          <template #default="{ row }">
            <span class="item-name">{{ row.name || row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="200">
          <template #default="{ row }">
            <span class="item-name">{{ row.description || '' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleViewDetail(row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 空状态 -->
      <el-empty v-if="!loading && displayData.length === 0" description="暂无相关数据" />

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="total"
          @current-change="handleCurrentChange" layout="prev, pager, next" background />
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import { Loading } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'

const props = defineProps({
  // 搜索类别
  category: {
    type: String,
    required: true
  },
  // 搜索关键词
  query: {
    type: String,
    required: true
  },
  // 搜索结果数据
  results: {
    type: Array,
    default: () => []
  },
  // 加载状态
  loading: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()
const currentPage = ref(1)
const pageSize = ref(10)



// 计算总数据量
const total = computed(() => props.results.length)

// 计算当前页显示的数据
const displayData = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value
  const end = start + pageSize.value
  return props.results.slice(start, end)
})

// 处理页码变化
const handleCurrentChange = (page) => {
  currentPage.value = page
}

// 处理查看详情
const handleViewDetail = async (item) => {
  // 根据不同类别跳转到不同的详情页
  const routeMap = {
    'tmys.product.cloth': '/shop/clothing/',
    'tmys.product.material': '/shop/fabric/',
    'tmys.product.auxiliary': '/shop/accessory/',
    'tmys.product.equip': '/shop/equipment/',
    'tmys.order': '/shop/order/'
  }

  console.log('当前类别:', props.category)
  console.log('当前项目:', item)

  const basePath = routeMap[props.category]
  if (!basePath) {
    ElMessage.warning('未找到对应的路由路径')
    return
  }

  if (!item || !item.id) {
    ElMessage.warning('无效的项目信息')
    return
  }

  const targetPath = basePath + item.id
  console.log('跳转路径:', targetPath)

  try {
    // 检查路由是否存在
    const route = router.resolve(targetPath)
    if (!route.matched.length) {
      ElMessage.error('页面不存在')
      return
    }

    window.open(targetPath, '_blank')
  } catch (error) {
    console.error('路由跳转失败:', error)
    ElMessage.error('页面跳转失败')
  }
}
</script>

<style scoped>
.search-by-search {
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  background: #fff;
  border-radius: 12px;
}

.result-table {
  margin-bottom: 24px;
}

:deep(.el-table) {
  --el-table-border-color: var(--el-border-color-lighter);
  --el-table-border: 1px solid var(--el-table-border-color);
  border: var(--el-table-border);
  border-radius: 8px;
  overflow: hidden;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #606266;
  padding: 12px 0;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table__row) {
  cursor: pointer;
  transition: all 0.3s ease;
}

:deep(.el-table__row:hover) {
  background-color: #f5f7fa;
  transform: translateY(-1px);
}

.item-name {
  font-size: 14px;
  color: #303133;
  transition: color 0.3s ease;
}

:deep(.el-table__row:hover .item-name) {
  color: #409EFF;
}

.item-price {
  color: #f56c6c;
  font-weight: bold;
}

.pagination-container {
  margin-top: 24px;
  text-align: center;
  padding: 16px 0;
}

:deep(.el-pagination) {
  --el-pagination-button-bg-color: #f5f7fa;
  --el-pagination-hover-color: #409EFF;
  --el-pagination-active-color: #409EFF;
}

:deep(.el-pagination .el-pager li) {
  border-radius: 4px;
  transition: all 0.3s ease;
}

:deep(.el-pagination .el-pager li:hover) {
  background-color: #ecf5ff;
}

:deep(.el-pagination .el-pager li.active) {
  background-color: #409EFF;
  color: #fff;
}

:deep(.el-button--primary.is-link) {
  color: #409EFF;
  font-weight: 500;
  transition: all 0.3s ease;
}

:deep(.el-button--primary.is-link:hover) {
  color: #66b1ff;
  transform: translateX(2px);
}
</style>